import React from 'react';
import { XCircle, ArrowLeft } from 'lucide-react';
import '../../styles/realsignal-theme.css';

interface BillingCancelProps {
    onRetry?: () => void;
    onSignIn?: () => void;
}

const colors = {
    background: '#0F1A24',
    backgroundLight: '#162434',
    backgroundCard: '#1C2E42',
    textPrimary: '#E6EBF0',
    textSecondary: '#A9B4C2',
    textMuted: '#7F8C9C',
    accent: '#3A6A7A',
    accentLight: '#4A8A9A',
    border: '#1C2E42',
    warning: '#F59E0B',
};

export const BillingCancel: React.FC<BillingCancelProps> = ({ onRetry, onSignIn }) => {
    return (
        <div
            className="min-h-screen flex items-center justify-center"
            style={{
                background: colors.background,
                fontFamily:
                    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            }}
        >
            <div className="w-full max-w-md mx-auto px-6 py-8">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="flex justify-center mb-4">
                        <img
                            src="/assets/realsignal-logo.png"
                            alt="RealSignal"
                            className="h-12 w-auto"
                            style={{ filter: 'brightness(1.15)' }}
                        />
                    </div>
                </div>

                {/* Cancel Card */}
                <div
                    style={{
                        background: `linear-gradient(145deg, ${colors.backgroundCard} 0%, ${colors.backgroundLight} 100%)`,
                        border: `1px solid ${colors.border}`,
                        borderRadius: '2rem',
                        padding: '2.5rem',
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                        textAlign: 'center',
                    }}
                >
                    <XCircle className="w-16 h-16 mx-auto mb-6" style={{ color: colors.warning }} />
                    <h2
                        style={{
                            fontSize: '1.5rem',
                            fontWeight: 700,
                            color: colors.textPrimary,
                            marginBottom: '0.5rem',
                        }}
                    >
                        Payment Cancelled
                    </h2>
                    <p style={{ color: colors.textSecondary, marginBottom: '1.5rem' }}>
                        Your payment was not completed. Your account has been created but is not yet
                        active.
                    </p>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <button
                            onClick={onRetry}
                            style={{
                                width: '100%',
                                background: `linear-gradient(135deg, ${colors.accent} 0%, ${colors.accentLight} 100%)`,
                                color: 'white',
                                fontWeight: 600,
                                padding: '1rem 1.5rem',
                                borderRadius: '1.5rem',
                                border: 'none',
                                cursor: 'pointer',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                            }}
                        >
                            Try Again
                        </button>

                        <button
                            onClick={onSignIn}
                            style={{
                                width: '100%',
                                background: 'transparent',
                                color: colors.textSecondary,
                                fontWeight: 500,
                                padding: '0.75rem 1.5rem',
                                borderRadius: '1rem',
                                border: `1px solid ${colors.border}`,
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '0.5rem',
                            }}
                        >
                            <ArrowLeft className="w-4 h-4" />
                            Return to Sign In
                        </button>
                    </div>

                    <p
                        style={{
                            fontSize: '0.75rem',
                            color: colors.textMuted,
                            marginTop: '1.5rem',
                        }}
                    >
                        Need help? Contact support@realsignal.io
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BillingCancel;
